import React, { useMemo } from 'react'
import { Outlet, useMatches } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from '../store/index.js'
import RouterNavigateBinder from '@src/lib/RouterNavigateBinder'
// import GtmPageViewTracker from '@src/lib/GtmPageViewTracker'
import ErrorBoundary from './components/ErrorBoundary'
import ErrorFallbacks from './components/ErrorFallbacks'
import AppComponent from './components/AppComponent'

type LayoutProps = Record<string, unknown>

export default function App() {
  const matches = useMatches()
  const layoutProps: LayoutProps = useMemo(() => {
    const reverse = [...matches].reverse()
    for (const m of reverse) {
      const handle = m.handle as { getLayoutProps?: () => LayoutProps } | undefined
      if (handle?.getLayoutProps) return handle.getLayoutProps() || {}
    }
    return {}
  }, [matches])

  return (
    <Provider store={store as never}>
      <div style={{ marginLeft: 'auto', height: 0, width: '6px'}}>*</div>
      <ErrorBoundary FallbackComponent={() => <ErrorFallbacks statusCode={1000} />}>
        <RouterNavigateBinder />
        {/* page_view disabled; context params are merged into other events */}
        {/* <GtmPageViewTracker /> */}
        <AppComponent layoutProps={layoutProps} pageProps={{}}>
          <Outlet />
        </AppComponent>
      </ErrorBoundary>
    </Provider>
  )
}
